<template>
    <table class="table table-desktop" :class="tableClass">
        <thead>
        <tr>
            <th v-for="(column, index) in columns"
                :class="{'activeColumn': activeColumn === index, 'c-pointer': isSortable(column)}"
                v-on:click="setSortable(column)"
            >
                {{ column.name }}
                <div class="sort" v-if="isSortable(column) === true"
                     :class="{'active': column.key === sortable.key}">
                    <font-awesome-icon :icon="getSortIcon(column)"/>
                </div>
            </th>
            <th class="actions" v-if="buttons.length !== 0">
                {{t('Actions')}}
            </th>
        </tr>
        </thead>
        <tbody>
        <tr class="filter" v-if="isSetFilter === true">
            <td v-for="(column, index) in columns">
                <grid-filter v-if="column.filter !== undefined"
                             :settings="column.filter"
                             :column="column"
                             v-on:changed="setConditions(column, $event)"
                             v-on:removed="resetFilter(column)"
                />
            </td>
            <td v-if="buttons.length !== 0">

            </td>
        </tr>
        <tr v-if="loading === false && items.length === 0">
            <td :colspan="buttons.length === 0 ? columns.length : (columns.length + 1)" class="text-center p-3">
                {{t('No items found')}}
            </td>
        </tr>
        <tr v-if="loading === true">
            <td :colspan="buttons.length === 0 ? columns.length : (columns.length + 1)" class="text-center p-3">
                <loading size="xs" />
                {{t('Loading')}}
            </td>
        </tr>
        <tr v-for="item in items" v-if="loading === false" :class="getRowClass(item)">
            <td v-for="(column, index) in columns"
                :class="getColumnClass(column, index)"
                v-on:click="setColumnAsActive(index, column)"
            >
                <div class="td-content">
                    <slot :name="column.key" :item="item"></slot>
                </div>
            </td>
            <td class="actions align-middle" v-if="buttons.length !== 0">
                <slot name="before-actions" :item="item"></slot>
                <buttons v-on:button="$emit('buttonEvent', {item: item, event: $event})"
                         :data="item"
                         :buttons="buttons"
                />
                <slot name="after-actions" :item="item"></slot>
            </td>
        </tr>
        </tbody>
    </table>
</template>
<script>
    import {table} from './Table';
    import Loading from '../../Components/loading';

    export default {
        mixins: [table],
        components: {Loading},
        props: {},
        computed: {
            tableClass() {
                return this.hasScrollAbleColumn() === true ? 'table-scrollable': '';
            }
        },
        methods: {
            hasScrollAbleColumn() {
                return this.columns.find(res => {
                    return res.scrollable === true;
                }) !== undefined;
            },
            getColumnClass(column, index) {
                let styleClass = 'titan-grid-column-' + column.key;
                if (this.activeColumn === index) {
                    styleClass += ' activeColumn';
                }
                if (column.scrollable === true) {
                    styleClass += ' scrollable';
                }
                return styleClass;
            },
            setColumnAsActive(index, column) {
                if (column.scrollable === true) {
                    this.activeColumn = this.activeColumn === index ? null : index;
                }
            }
        },
        data() {
            return {
                activeColumn: null
            };
        }
    }
</script>
<style lang="scss">
    table.table-desktop {
        &.table-scrollable {
            table-layout: fixed;
            th {
                width: 50px;
            }
        }

        th {
            padding: 8px;
            color: lighten(#000, 35%);
            background: #F4F5F7;

            &.actions {
                white-space: nowrap;
            }

            &.activeColumn {
                width: 200px ! important;
            }
        }

        tr.filter {
            td {
                padding: 5px;
            }
            .form-control {
                border-width: 0;

                &::placeholder {
                    color: #d6d6d6;
                }
            }
        }

        th, td {
            border-color: #EFF1F4;
        }

        thead {
            th {
                position: relative;

                > .sort {
                    position: absolute;
                    top: 11px;
                    right: 6px;
                    font-size: 13px;

                    &:not(.active) {
                        color: #b1b9c1;
                    }
                }
            }
        }

        tbody {
            background: #fff;
        }

        td {
            font-size: 15px;
            line-height: 17px;

            position: relative;
            box-sizing: border-box;
            transition: background .4s;
            border-top-width: 2px;
            border-right: 1px solid #EFF1F4;
            vertical-align: middle;
            padding: 0;


            &.scrollable:not(.activeColumn) {
                white-space: nowrap;
            }

            .td-content {
                display: inline-block;
                box-sizing: border-box;
                width: 100%;
                border-left: 1em solid transparent;
                border-right: 1em solid transparent;
                padding: 13px 0;
            }

            &.actions {
                padding: 8px 8px 5px;
                .btn {
                    margin-bottom: 3px;
                }
            }

            &.scrollable .td-content {
                overflow: hidden;
                cursor: pointer;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/core/InlineDataGrid/tables/Desktop.vue